<template>
    <div id="orderlist">
        <el-row>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top:24px">
                <el-breadcrumb-item :to="{ path: '/storageDocument' }" style="font-size:24px">出库单管理</el-breadcrumb-item>
                <el-breadcrumb-item style="font-size:24px">出库单详情</el-breadcrumb-item>
            </el-breadcrumb>
        </el-row>
        <el-row style="margin-top: 20px">
            <el-col :span="10">
                <span>出库单编号：{{deliverCode}}</span>
            </el-col>
            <el-col :span="5">
                <span>出库时间：{{deliverDay}}</span>
            </el-col>
            <el-col :span="5">
                <span>档口：{{dkName}}</span>
            </el-col>
            <el-col :span="5">
                <span>产品数量：{{totalNum}}</span>
            </el-col>
            <el-col :span="5">
                <span>总金额：{{totalFee}}</span>
            </el-col>
        </el-row>
        <el-row style="margin-top:20px">
            <el-col :span="24">
                <el-table :data="tableData" show-summary stripe border style="width: 100%">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="80"></el-table-column>
                    <el-table-column prop="PRODUCT_NAME" label="产品" min-width="80"></el-table-column>
                    <el-table-column prop="TYPE_UNIT" label="单位" min-width="45"></el-table-column>
                    <el-table-column prop="TOTAL_FEE" label="总价值" min-width="45" ></el-table-column>
                    <el-table-column prop="PICKER" label="领料人" min-width="45"></el-table-column>
                    <el-table-column prop="PRODUCT_COUNT" label="出库数量" ></el-table-column>
                    <el-table-column prop="HAVE_RETURN" label="是否退库" >
                        <template slot-scope="scope">
                            {{showLable(scope.row)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="RETURN_COUNT" label="已退库数量" min-width="60"></el-table-column>
                    <el-table-column prop="AFTER_COUNT" label="剩余数量" min-width="60"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-edit" size="small" @click="returnStorage(scope.row)">退库</el-button>
                            <el-button type="text" icon="el-icon-edit" size="small" @click="outStorage(scope.row)">修改出库数量</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-dialog
                        title="退库"
                        :visible.sync="returnDialogVisible"
                        width="30%"
                        center @close="close" :close-on-click-modal="false">
                    <el-form v-model="returnForm" ref="returnForm">
                        <el-form-item label="退库数量：" :label-width="formLabelWidth">
                            <el-input v-model="returnForm.COUNT"></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="close">取 消</el-button>
                        <el-button type="primary" @click="returnProduct">确 定</el-button>
                    </span>
                </el-dialog>
                <el-dialog
                        title="出库"
                        :visible.sync="outDialogVisible"
                        width="30%"
                        center @close="close" :close-on-click-modal="false">
                    <el-form v-model="outForm" ref="outForm">
                        <el-form-item label="出库数量：" :label-width="formLabelWidth">
                            <el-input v-model="outForm.PRODUCT_COUNT"></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="close">取 消</el-button>
                        <el-button type="primary" @click="outProduct">确 定</el-button>
                    </span>
                </el-dialog>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import http from '@/api/base/http';

export default {
  data() {
    return {
      tableData: [],
      deliverCode: '',
      deliverDay: '',
      dkName: '',
      totalFee: '',
      totalNum: '',
      returnForm: {},
      returnDialogVisible: false,
      formLabelWidth: '100px',
      outDialogVisible: false,
      outForm: {},
    };
  },
  created() {
    this.queryDetail();
  },
  methods: {
    queryDetail() {
      const params = {
        DELIVER_ID: this.$route.params.id,
        SERVICE_ID: '11002',
        OTYPE: 2,
      };
      http.post(params).then((result) => {
        console.log(result);
        this.tableData = result[0].DATA;
        this.totalFee = result[0].TOTAL_FEE;
        this.deliverCode = result[0].DELIVER_CODE;
        this.deliverDay = result[0].DELIVER_DAY;
        this.dkName = result[0].DK_NAME;
        this.totalNum = result[0].ALL_PRODUCT_COUNT;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    showLable(row) {
      if (row.HAVE_RETURN == 0) {
        return '无退库';
      }
      return '有退库';
    },
    returnStorage(row) {
      this.returnDialogVisible = true;
      this.returnForm = row;
      console.log(this.returnForm);
    },
    returnProduct() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            PRODUCT_COUNT: this.returnForm.COUNT,
            PROJECT_ID: sessionStorage.getItem('projectId'),
            PRODUCT_CODE: this.returnForm.PRODUCT_CODE,
            RECORD_ID: this.$route.params.id,
            DETAIL_ID: this.returnForm.DETAIL_ID,
            SERVICE_ID: '11002',
            OTYPE: 3,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '退库成功', type: 'success' });
            this.queryDetail();
            this.returnDialogVisible = false;
            document.body.style.cursor = 'default';
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    close() {
      this.returnDialogVisible = false;
    },
    outStorage(row) {
      this.outDialogVisible = true;
      this.outForm = row;
    },
    outProduct() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            PRODUCT_COUNT: this.outForm.PRODUCT_COUNT,
            PROJECT_ID: sessionStorage.getItem('projectId'),
            PRODUCT_CODE: this.outForm.PRODUCT_CODE,
            RECORD_ID: this.$route.params.id,
            DETAIL_ID: this.outForm.DETAIL_ID,
            SERVICE_ID: '11002',
            OTYPE: 4,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '出库成功', type: 'success' });
            this.queryDetail();
            this.outDialogVisible = false;
            document.body.style.cursor = 'default';
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/storageDetail.vue